type Mapbox = typeof import("mapbox-gl")["default"];

let mapboxPromise: Promise<Mapbox> | undefined;

export function loadMapbox(): Promise<Mapbox> {
	mapboxPromise ??= Promise.all([
		import("mapbox-gl/dist/mapbox-gl.css"),
		import("mapbox-gl"),
	]).then(([, module]) => module.default);

	return mapboxPromise;
}